import { useQuery } from '@apollo/client';
import { StaffFinanceDetailContainerGlTransactionSummariesByDateRangeDocument, StaffFinanceDetailContainerGlTransactionSummaryFieldsFragment } from '../../../../generated';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { FinanceDetail } from './finance-detail';
import { useState } from 'react';

interface FinanceDetailContainerProps {}

export const FinanceDetailContainer: React.FC<FinanceDetailContainerProps> = () => {
  const [filterDates, setFilterDates] = useState<{ startDate: string | null; endDate: string | null } | null>({ startDate: null, endDate: null });

  const {
    data: financeDetailData,
    loading: financeDetailLoading,
    error: financeDetailError
  } = useQuery(StaffFinanceDetailContainerGlTransactionSummariesByDateRangeDocument, {
    variables: {
      startDate: filterDates?.startDate,
      endDate: filterDates?.endDate
    }
  });

  return (
    <ComponentQueryLoader
      loading={financeDetailLoading}
      error={financeDetailError}
      hasData={!!financeDetailData}
      hasDataComponent={
        <FinanceDetail
          data={financeDetailData?.glTransactionSummariesByDateRange as StaffFinanceDetailContainerGlTransactionSummaryFieldsFragment[]}
          setFilterDates={setFilterDates}
          filterDates={filterDates}
        />
      }
    />
  );
};
